module.exports = __webpack_public_path__ + "img/destination-4.67b0ebe0.svg";